module.exports = __webpack_public_path__ + "img/amex.a38476d0.svg";